export default __webpack_public_path__ + "static/media/popup-header-cross.b30f3707.svg";